export default function PHP_new() {
  return (
    <div>
      <h1>PHP_new</h1>
    </div>
  );
}
